import React, { useState, useMemo } from "react";
import { BANKS } from "../lib/banks";
import { Search, ChevronDown } from "lucide-react";

export function BankSelect({ value, onChange, disabled }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    if (!search) return BANKS;
    const s = search.toLowerCase();
    return BANKS.filter(b => b.label.toLowerCase().includes(s) || b.code.includes(s));
  }, [search]);

  const selected = BANKS.find(b => b.code === value || b.label === value);

  return (
    <div className="relative">
      <button
        type="button"
        disabled={disabled}
        onClick={() => !disabled && setOpen(!open)}
        className="w-full h-10 rounded-md border border-input px-3 text-sm text-left flex items-center justify-between bg-white disabled:opacity-50 disabled:cursor-not-allowed"
        data-testid="bank-select-trigger"
      >
        <span className={`truncate ${selected ? "text-zinc-900" : "text-zinc-400"}`}>
          {selected ? selected.label : "Selecione o banco"}
        </span>
        <ChevronDown className="h-4 w-4 text-zinc-400 flex-shrink-0" />
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute z-50 top-full left-0 mt-1 w-full bg-white border border-[var(--zemo-border)] rounded-md shadow-lg max-h-64 overflow-hidden flex flex-col">
            <div className="p-2 border-b border-[var(--zemo-border)]">
              <div className="relative">
                <Search className="h-3.5 w-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-zinc-400" />
                <input
                  type="text"
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                  placeholder="Buscar banco..."
                  className="w-full h-8 pl-8 pr-3 text-sm rounded border border-input focus:outline-none focus:ring-1 focus:ring-[#0055FF]"
                  autoFocus
                />
              </div>
            </div>
            <div className="overflow-y-auto flex-1">
              {filtered.length === 0 ? (
                <div className="px-3 py-4 text-sm text-zinc-500 text-center">Nenhum banco encontrado</div>
              ) : filtered.map((bank, idx) => (
                <button
                  // FS-247/B3: `code` NÃO é único na lista — as três entradas
                  // de infraestrutura da B3 (Câmara B3, Câmara de Câmbio B3,
                  // Sistema do Balcão B3) têm code "0", e o React reclamava de
                  // "two children with the same key". Chave composta com o
                  // nome (estável e independente do índice/filtro); a lista de
                  // dados fica intacta.
                  key={`${bank.code}-${bank.name}`}
                  type="button"
                  // FS-247: emite o CÓDIGO (COMPE-3), nunca o rótulo. O `banco`
                  // que sai daqui vai direto ao POST /cedente/bank-change e à
                  // coluna String(10) — mandar "237 | Banco Bradesco S.A." (24
                  // chars) derrubava a rota com 500 para todo cedente. A EXIBIÇÃO
                  // segue sendo o rótulo (`selected.label`, acima).
                  onClick={() => { onChange(bank.code); setOpen(false); setSearch(""); }}
                  className={`w-full text-left px-3 py-2 text-sm hover:bg-zinc-50 transition-colors ${
                    idx === 10 ? "border-t border-[var(--zemo-border)]" : ""
                  } ${value === bank.label || value === bank.code ? "bg-blue-50 text-[#0055FF] font-semibold" : "text-zinc-700"}`}
                >
                  {bank.label}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
